export default __webpack_public_path__ + "static/media/HI.6c7813ab.mp3";